export default __webpack_public_path__ + "static/media/Obliteratus.19701d44.jpg";